import { ProductListingHeader } from 'components/ProductListingHeader';
import { FC, useEffect, useState } from 'react';
import { useFetchProducts } from 'reactQuery/queries';
import { ProductListingContainerProps, Styled } from '.';
import { SortDirection } from 'types';
import { CategoryFilter, ProductListing } from 'components';
import { isIMSEnabled } from 'utils';
import getConfig from 'next/config';

const ProductListingWithoutCache: FC<ProductListingContainerProps> = ({
  taxonDetails,
}) => {
  const { publicRuntimeConfig } = getConfig();
  const storeRegion = publicRuntimeConfig.STORE_REGION;
  const [sortDirection, setSortDirection] = useState('');
  const [appliedCategoryFilters, setAppliedCategoryFilters] = useState<
    string[]
  >([]);

  const productsList = useFetchProducts({
    taxonSlug: taxonDetails.taxon.permalink,
    sortDirection: sortDirection,
    categoryFilters: appliedCategoryFilters,
  });

  const handleProductSorting = (sortType: SortDirection) => {
    setSortDirection(sortType);
  };

  const onSelectCategoryFilter = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.checked) {
      setAppliedCategoryFilters([
        ...appliedCategoryFilters,
        event.target.value,
      ]);
    } else {
      const filteredCategories = appliedCategoryFilters.filter(
        subCategoryId => subCategoryId !== event.target.value
      );
      setAppliedCategoryFilters(filteredCategories);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [appliedCategoryFilters]);

  useEffect(() => {
    if (
      taxonDetails.taxon.permalink.includes('practice-marketing') &&
      storeRegion === 'NA' &&
      isIMSEnabled()
    ) {
      setSortDirection(SortDirection.NewestFirst);
    } else {
      setSortDirection('');
    }
  }, [taxonDetails.taxon.permalink]);

  return (
    <>
      <ProductListingHeader
        title={taxonDetails.taxon.title}
        totalProductCount={productsList.data?.pages[0].totalCount}
        onSort={handleProductSorting}
        sortDirection={sortDirection}
        isLoading={productsList.isLoading || productsList.isIdle}
      />
      <Styled.Main displayFilterSection={false}>
        <Styled.FilterWrapper>
          <Styled.FilterSectionSticky>
            <CategoryFilter
              categoryFilters={taxonDetails.taxonFilters.categories}
              onChange={onSelectCategoryFilter}
              appliedCategoryFilters={appliedCategoryFilters}
            />
          </Styled.FilterSectionSticky>
        </Styled.FilterWrapper>
        <Styled.ProductListingWrapper>
          <ProductListing productList={productsList} />
        </Styled.ProductListingWrapper>
      </Styled.Main>
    </>
  );
};

export default ProductListingWithoutCache;
